import createDecorator from "final-form-calculate";
import { Decorator } from "final-form";
import { FormValues } from "./types";

export const decorators = createDecorator({
  field: 'checkAllCheckboxes',
  updates: (_, __, allValues) => {
    const values = { ...allValues } as FormValues;
    const isCheckAllCheckboxesChecked = values.checkAllCheckboxes;

    if (!values.checkAllCheckboxesChangedAfterPlatformClick) {
      Object.keys(values.platforms).forEach(platformKey => {
        // @ts-ignore
        values.platforms[platformKey] = isCheckAllCheckboxesChecked;
      });
    }

    values.checkAllCheckboxesChangedAfterPlatformClick = false;
    return values;
  }
}, {
  field: 'platforms',
  updates: (_, __, allValues) => {
    const values = {...allValues} as FormValues;

    Object.values(values.platforms).forEach(platformValue => {
      if (!platformValue && values.checkAllCheckboxes) {
        values.checkAllCheckboxes = false;
        values.checkAllCheckboxesChangedAfterPlatformClick = true;
      }
    });

    return values;
  }
}, {
  field: 'checkAllDigitalFingerprintingSystemCheckboxes',
  updates: (_, __, allValues) => {
    const values = { ...allValues } as FormValues;
    const isCheckAllCheckboxesChecked = values.checkAllDigitalFingerprintingSystemCheckboxes;

    if (!values.checkAllDigitalFingerprintingSystemCheckboxesClick) {
      Object.keys(values.digitalFingerprintingSystem).forEach(platformKey => {
        // @ts-ignore
        values.digitalFingerprintingSystem[platformKey as keyof FormValues] = isCheckAllCheckboxesChecked;
      });
    }

    values.checkAllDigitalFingerprintingSystemCheckboxesClick = false;
    return values;
  }
}, {
  field: 'digitalFingerprintingSystem',
  updates: (_, __, allValues) => {
    const values = {...allValues} as FormValues;

    Object.values(values.platforms).forEach(platformValue => {
      if (!platformValue && values.checkAllDigitalFingerprintingSystemCheckboxes) {
        values.checkAllDigitalFingerprintingSystemCheckboxes = false;
        values.checkAllDigitalFingerprintingSystemCheckboxesClick = true;
      }
    });

    return values;
  }
}) as Decorator<FormValues>;
